import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes, { any } from 'prop-types';

import EndSection from '../PlayerCard/ListViewComponents/EndSection';
import MessageButton from '../PlayerCard/ListViewComponents/MessageButton';
import MessagePopover from '../PlayerCard/ListViewComponents/MessagePopover';
import PopOverMenu from '../../PopOverMenu';
import Img from '../../Img';
import PlayerBookmark, { BOOKMARK_ROW_ICON_HEIGHT } from '../../SavedLists/PlayerBookmark';

const CardContentV3 = props => {
    const {
        addOptionsSpace,
        enableMessaging,
        isCurrentMemberAdmin,
        isSelected,
        menuOptions,
        onMenuSelected,
        onMessageClick,
        onSelectClick,
        optionSpaceContent,
        player,
        showCheckbox,
        showPosition,
        showSeeProfileLink,
        showSaveBookmark,
        'data-testid': dataTestId,
    } = props;

    const {
        id: playerId,
        playerId: utrPlayerId,
        phone,
        email,
        position,
    } = player;

    const showMenuOptions = menuOptions?.length > 0;
    const showOptionsSpaceContent = !!optionSpaceContent;

    const handleSelectClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onSelectClick(player.memberId);
    };

    return (
        <div className={`list-view`} data-testid="player-card.list-view">
            <div className="d-flex">
                {showCheckbox && (
                    <div className="checkbox-wrapper" onClick={handleSelectClick} data-testid="player-card.select-checkbox">
                        <div className={`checkbox-check ${isSelected ? 'checked' : ''}`}><Img src="/img/icons/checkmark-icon.svg" /></div>
                    </div>
                )}
                {showPosition && (
                    <div className={`asc w32 d-flex aic mr8 ${showCheckbox ? 'jcc' : ''}`}>
                        {position || '--'}
                    </div>
                )}
                <div className="flex-grow">
                    <div className="row">
                        {props.children}
                    </div>
                </div>
                <EndSection className={showSaveBookmark ? 'has-save-bookmark' : ''}>
                    {enableMessaging && (isCurrentMemberAdmin ? (
                        <MessagePopover onMessageClick={onMessageClick} email={email} phone={phone} />
                    ) : (
                        <MessageButton onMessageClick={onMessageClick} />
                    ))}
                    {showSaveBookmark && utrPlayerId && (
                        <PlayerBookmark
                            playerId={utrPlayerId}
                            playerName={[player.firstName, player.lastName].filter(Boolean).join(' ') || undefined}
                            isSaved={player.isSaved}
                            className="text-v3-blue"
                            size={BOOKMARK_ROW_ICON_HEIGHT}
                            data-testid={dataTestId && `${dataTestId}.player-bookmark-${utrPlayerId}`}
                        />
                    )}
                    {showMenuOptions && (
                        <PopOverMenu
                            horizontalEllipsis={false}
                            menuItems={menuOptions}
                            onSelected={onMenuSelected}
                            data-testid="player-card.actions-menu"
                        />
                    )}
                    {!menuOptions && (
                        <>
                            {showSeeProfileLink && (
                                <Link to={`/profiles/${playerId}`} target="_blank" data-testid="player-card.view-profile-link">
                                    <span className={`extra-card-link`}>View Profile</span>
                                </Link>
                            )}
                            {addOptionsSpace && (
                                <div className="options-space" />
                            )}
                            {showOptionsSpaceContent && (
                                <div className="fs14">{optionSpaceContent}</div>
                            )}
                        </>
                    )}
                </EndSection>
            </div>
        </div>
    );
};

CardContentV3.propTypes = {
    addOptionsSpace: PropTypes.bool,
    enableMessaging: PropTypes.bool,
    isCurrentMemberAdmin: PropTypes.bool,
    isSelected: PropTypes.bool,
    menuOptions: PropTypes.arrayOf(any),
    onMenuSelected: PropTypes.func,
    onMessageClick: PropTypes.func,
    onSelectClick: PropTypes.func,
    optionSpaceContent: PropTypes.string,
    showCheckbox: PropTypes.bool,
    showSeeProfileLink: PropTypes.bool,
    showPosition: PropTypes.bool,
    showSaveBookmark: PropTypes.bool,
    'data-testid': PropTypes.string,
    player: PropTypes.objectOf(any).isRequired,
};

CardContentV3.defaultProps = {
    addOptionsSpace: false,
    enableMessaging: false,
    isCurrentMemberAdmin: false,
    isSelected: false,
    menuOptions: null,
    onMenuSelected: () => { },
    onMessageClick: () => { },
    onSelectClick: () => { },
    optionSpaceContent: '',
    showCheckbox: false,
    showSeeProfileLink: false,
    showPosition: false,
    showSaveBookmark: false,
    'data-testid': null,
};

export default CardContentV3;
